import { calculationLimits, designFastVariables, designRoadClasses } from "store/calculation.config";
import { calculateBrakingFriction } from "utilities/genericRoadUtilities/calculateBrakingFriction";
import { calculateSpeedProfileAddition } from "utilities/genericRoadUtilities/calculateSpeedProfileAddition";

export const calculateVertical = (input) => {
    const errors = {
        TOOLS_SPEEDLIMIT_TOO_LOW: false,
        TOOLS_SPEEDLIMIT_TOO_HIGH: false,
        TOOLS_LONGITUDAL_SLOPE_TOO_LOW: false,
        TOOLS_LONGITUDAL_SLOPE_TOO_HIGH: false,
        TOOLS_HORIZONTAL_RADIUS_IS_EQUAL_ZERO: false,
        TOOLS_LIGHTS_HEIGHT_TOO_LOW: false,
        TOOLS_LIGHTS_HEIGHT_TOO_HIGH: false,
        TOOLS_LIGHTS_ANGLE_TOO_LOW: false,
        TOOLS_LIGHTS_ANGLE_TOO_HIGH: false,
        TOOLS_LONGITUDAL_SLOPES_DO_NOT_FORM_CREST_CURVE: false,
        TOOLS_BRAKING_FRICTION_CALCULATED_BY_REGRESSION: false,
    }

    let calculationContext = {
        normalizedInput: {...input},
        wasNormalized: false,
        errorsToSet: [],
        errorsToUnset: [],
        input:
        {
            designClass: {value: null, valid: null, severity: null},
            speedlimit: {value: null, valid: null, severity: null},
            firstSlope: {value: null, valid: null, severity: null},
            secondSlope: {value: null, valid: null, severity: null},
            horizontalCurveRadius: {value: null, valid: null, severity: null},
            lightsHeight: {value: null, valid: null, severity: null},
            lightsAngle: {value: null, valid: null, severity: null}
        },
        derived:
        {
            computationalEyeHeight: {value: designFastVariables.computationalEyeHeight, valid: null, severity: null},
            computationalObjectHeight: {value: designFastVariables.computationalObjectHeight, valid: null, severity: null},
            computationalVehicleHeight: {value: designFastVariables.computationalVehicleHeight, valid: null, severity: null},
            brakingFriciton: {value: null, valid: null, severity: null},
            safetyFactor: {value: null, valid: null, severity: null},
            speedAddition: {value: null, valid: null, severity: null},
            speedProfileAddition: {value: null, valid: null, severity: null},
            reactionTime: {value: designFastVariables.reactionTime, valid: null, severity: null},
            verticalAcceleration: {value: designFastVariables.verticalAcceleration, valid: null, severity: null},
        },
        output:
        {
            stopDistance: {value: null, valid: null, severity: null},
            verticalLongCrestCurveRadius: {value: null, valid: null, severity: null},
            verticalLongCrestCurveLength: {value: null, valid: null, severity: null},
            verticalShortCrestCurveRadius: {value: null, valid: null, severity: null},
            verticalNormalSagCurveRadius: {value: null, valid: null, severity: null},
            verticalDarkSagCurveRadius: {value: null, valid: null, severity: null},
        }
    };

    validateValues(calculationContext, errors);
    validateRelations(calculationContext, errors);
    calculateDerived(calculationContext, errors);
    calculateOutput(calculationContext, errors);

    calculationContext.errorsToSet = Object.keys(errors).filter(key => errors[key]);
    calculationContext.errorsToUnset = Object.keys(errors).filter(key => !errors[key]);
    console.log(calculationContext);
    return calculationContext;
}

const validateValues = (ctx, errors) => {

    // #region validating design class
    if(ctx.normalizedInput.designClass.trim() !== '')
    {
        
        let designClassObject = designRoadClasses[ctx.normalizedInput.designClass];
        if(designClassObject) ctx.input.designClass = {value: designClassObject, valid: true, severity: null};
        else ctx.input.designClass = {value: null, valid: false, severity: 'error'};
    }
    // #endregion

    // #region speedlimit
    if(ctx.normalizedInput.speedlimit.trim() !== '')
    {
        const speedlimit = Number(ctx.normalizedInput.speedlimit.trim());
        if(speedlimit < calculationLimits.minSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_LOW = true;
        }
        else if(speedlimit > calculationLimits.maxSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_HIGH = true;
        }
        else
        {
            ctx.input.speedlimit = {value: speedlimit, valid: true, severity: null};
        }
    }
    // #endregion

    // #region first slope
    if(ctx.normalizedInput.firstSlope.trim() !== '')
    {
        const firstSlope = Number(ctx.normalizedInput.firstSlope.trim());
        if(firstSlope < calculationLimits.minLongitudalSlope)
        {
            ctx.input.firstSlope = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LONGITUDAL_SLOPE_TOO_LOW = true;
        }
        else if(firstSlope > calculationLimits.maxLongitudalSlope)
        {
            ctx.input.firstSlope = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LONGITUDAL_SLOPE_TOO_HIGH = true;
        }
        else
        {
            ctx.input.firstSlope = {value: firstSlope, valid: true, severity: null};
        }
    }
    // #endregion

    // #region second slope
    if(ctx.normalizedInput.secondSlope.trim() !== '')
    {
        const secondSlope = Number(ctx.normalizedInput.secondSlope.trim());
        if(secondSlope < calculationLimits.minLongitudalSlope)
        {
            ctx.input.secondSlope = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LONGITUDAL_SLOPE_TOO_LOW = true;
        }
        else if(secondSlope > calculationLimits.maxLongitudalSlope)
        {
            ctx.input.secondSlope = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LONGITUDAL_SLOPE_TOO_HIGH = true;
        }
        else
        {
            ctx.input.secondSlope = {value: secondSlope, valid: true, severity: null};
        }
    }
    // #endregion

    // #region horizontal radius
    if(ctx.normalizedInput.horizontalCurveRadius.trim() !== '')
    {
        const horizontalCurveRadius = Number(ctx.normalizedInput.horizontalCurveRadius.trim());

        if(horizontalCurveRadius === 0)
        {
            ctx.input.horizontalCurveRadius = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_HORIZONTAL_RADIUS_IS_EQUAL_ZERO = true;
        }
        else
        {
            ctx.input.horizontalCurveRadius = {value: horizontalCurveRadius, valid: true, severity: null};
        }
    }
    // #endregion

    // #region lights height
    if(ctx.normalizedInput.lightsHeight.trim() !== '')
    {
        const lightsHeight = Number(ctx.normalizedInput.lightsHeight.trim());
        if(lightsHeight < calculationLimits.minLightsHeight)
        {
            ctx.input.lightsHeight = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LIGHTS_HEIGHT_TOO_LOW = true;
        }
        else if(lightsHeight > calculationLimits.maxLightsHeight)
        {
            ctx.input.lightsHeight = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LIGHTS_HEIGHT_TOO_HIGH = true;
        }
        else
        {
            ctx.input.lightsHeight = {value: lightsHeight, valid: true, severity: null};
        }
    }
    // #endregion

    // #region lights angle
    if(ctx.normalizedInput.lightsAngle.trim() !== '')
    {
        const lightsAngle = Number(ctx.normalizedInput.lightsAngle.trim());
        if(lightsAngle < calculationLimits.minLightsAngle)
        {
            ctx.input.lightsAngle = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LIGHTS_ANGLE_TOO_LOW = true;
        }
        else if(lightsAngle > calculationLimits.maxLightsAngle)
        {
            ctx.input.lightsAngle = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LIGHTS_ANGLE_TOO_HIGH = true;
        }
        else
        {
            ctx.input.lightsAngle = {value: lightsAngle, valid: true, severity: null};
        }
    }
    // #endregion
}

const validateRelations = (ctx, errors) => {

    if(ctx.input.firstSlope.valid && ctx.input.secondSlope.valid)
    {
        if(ctx.input.secondSlope.value >= ctx.input.firstSlope.value)
        {
            errors.TOOLS_LONGITUDAL_SLOPES_DO_NOT_FORM_CREST_CURVE = true;
            ctx.input.secondSlope = {
                value: null,
                valid: false,
                severity: 'warning'
            };
        }
    }
}

const calculateDerived = (ctx, errors) => {
    if(ctx.input.designClass.valid)
    {
        ctx.derived.speedAddition = {
            value: ctx.input.designClass.value.speedAddition,
            valid: true,
            severity: null
        };

        ctx.derived.safetyFactor = {
            value: ctx.input.designClass.value.safetyFactor,
            valid: true,
            severity: null
        };

        if(ctx.input.horizontalCurveRadius.valid)
        {
            ctx.derived.speedProfileAddition = {
                value: calculateSpeedProfileAddition(
                    ctx.input.designClass.value,
                    ctx.input.horizontalCurveRadius.value
                ),
                valid: true,
                severity: null
            };
        }

        if(ctx.input.speedlimit.valid)
        {
            ctx.derived.brakingFriciton = {
                value: calculateBrakingFriction(ctx.input.speedlimit.value + ctx.derived.speedAddition.value + ctx.derived.speedProfileAddition.value)/ctx.derived.safetyFactor.value,
                valid: true,
                severity: null
            }

            if((ctx.input.speedlimit.value + ctx.derived.speedAddition.value + ctx.derived.speedProfileAddition.value) % 10 !== 0)
            {
                errors.TOOLS_BRAKING_FRICTION_CALCULATED_BY_REGRESSION = true;
            }
        }
    }
}

const calculateOutput = (ctx) => {

    if(ctx.input.designClass.valid && ctx.input.firstSlope.valid && ctx.input.speedlimit.valid )
    {
        ctx.output.stopDistance = {
            value: 0.278 * ctx.derived.reactionTime.value * (ctx.input.speedlimit.value + ctx.derived.speedAddition.value + ctx.derived.speedProfileAddition.value)
                + (ctx.input.speedlimit.value + ctx.derived.speedAddition.value + ctx.derived.speedProfileAddition.value)**2 / (254.3 * (ctx.derived.brakingFriciton.value + ctx.input.firstSlope.value)),
            valid: true,
            severity: null,
        };

        ctx.output.verticalLongCrestCurveRadius = {
            value: 0.5 * (ctx.output.stopDistance.value/(Math.sqrt(ctx.derived.computationalEyeHeight.value) + Math.sqrt(ctx.derived.computationalObjectHeight.value)))**2,
            valid: true,
            severity: null
        }

        if(ctx.input.secondSlope.valid)
        {
            const x1 = -(ctx.input.firstSlope.value * ctx.output.verticalLongCrestCurveRadius.value)/(Math.sqrt(1 + ctx.input.firstSlope.value**2));
            const x2 = -(ctx.input.secondSlope.value * ctx.output.verticalLongCrestCurveRadius.value)/(Math.sqrt(1 + ctx.input.secondSlope.value**2));
            
            ctx.output.verticalLongCrestCurveLength = {
                value: ctx.output.verticalLongCrestCurveRadius.value * Math.abs(Math.acos(x2/ctx.output.verticalLongCrestCurveRadius.value) - Math.acos(x1/ctx.output.verticalLongCrestCurveRadius.value)),
                valid: true,
                severity: null
            };

            const slopeDifference = Math.abs(ctx.input.secondSlope.value - ctx.input.firstSlope.value);
            const verticalShortCrestCurveRadius = (2 * ctx.output.stopDistance.value/slopeDifference) - 2 * ((Math.sqrt(ctx.derived.computationalEyeHeight.value) + Math.sqrt(ctx.derived.computationalObjectHeight.value))/slopeDifference)**2;

            if(verticalShortCrestCurveRadius < 0)
            {
                ctx.output.verticalShortCrestCurveRadius = {
                    value: null,
                    valid: false,
                    severity: 'warning'
                };
            }
            else
            {
                ctx.output.verticalShortCrestCurveRadius = {
                    value: verticalShortCrestCurveRadius,
                    valid: true,
                    severity: null
                };
            }
        }
    }

    if(ctx.input.speedlimit.valid)
    {
        ctx.output.verticalNormalSagCurveRadius = {
            value: (ctx.input.speedlimit.value + ctx.derived.speedAddition.value + ctx.derived.speedProfileAddition.value)**2 / (12.96 * ctx.derived.verticalAcceleration.value),
            valid: true,
            severity: null
        }

        if(ctx.input.designClass.valid && ctx.input.lightsAngle.valid && ctx.input.lightsHeight.valid && ctx.input.firstSlope.value)
        {
            ctx.output.verticalDarkSagCurveRadius = {
                value: (ctx.output.stopDistance.value**2) / (2 * (ctx.input.lightsHeight.value + ctx.output.stopDistance.value * Math.tan(Math.PI/180 * ctx.input.lightsAngle.value))),
                valid: true,
                severity: null
            }
        }
    }
}